export interface Topic {
  Id: string;
  Name: string;
  Slug: string;
  ArticleCount: number;
  Url: string;
  DisplayPriority: number;
  CategoryId: string | null;
}

export interface Category {
  Id: string;
  Name: string;
  DisplayPriority: number;
  Icon?: string | null;
}

export interface ArticleStatListItem {
  id: string;
  topicId: string;
  topicName: string;
  slug: string;
  title: string;
  description: string;
  hitCount: number;
  voteCount: number;
  helpfulCount: number;
  updatedAt: string;
  visibility: "Public" | "Internal";
  isPublished: boolean;
  url: string;
  botSummary?: string;
  enableBotResponse?: boolean;
}

export enum ArticleVisibility {
  Public,
  Internal
}

export interface Article {
  Id: string;
  TopicId: string;
  Visibility: ArticleVisibility;
  CreatedAt: string;
  Title: string;
  Slug: string;
  Content: string;
  Description: string;
  SearchTags: string;
  BotSummary?: string;
  EnableBotResponse?: boolean;
}

export interface DraftListItem {
  Id: string;
  TopicId: string;
  Slug: string;
  Title: string;
  Description: string;
}
